const RELOADED = 'stale_chunk_reloaded';

function serverAnswers(): Promise<boolean> {
  return fetch(window.location.pathname, { method: 'HEAD', cache: 'no-store' }).then(
    (res) => res.ok,
    () => false,
  );
}

export function installStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', () => {
    if (sessionStorage.getItem(RELOADED)) return;
    void serverAnswers().then((online) => {
      if (!online || sessionStorage.getItem(RELOADED)) return;
      sessionStorage.setItem(RELOADED, '1');
      window.location.reload();
    });
  });
}
